<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card>
			<div class="flex text-right">
				<b-button variant="outline-primary" @click="fetchDrivers" class="my-3">{{ $t("global.search") }}</b-button>
			</div>

			<div id="drivers-map" ref="drivers-map" class="map"></div>
		</b-card>
		<b-modal v-model="modalShow" v-if="modalShow"  size="xl">
			<b-card class="mb-3 shadow-sm card-custom" >
				<div class="d-flex align-items-center justify-content-center">
					<!-- Driver Image -->
					<img :src="locationSelected.driver.image" class="rounded-circle mr-4" :alt="driverName"
						style="width: 100px; height: 100px;">
					<!-- Driver Info -->
					<div>
						<h5 class="mb-0">{{ driverName }}</h5>
						<p class="text-muted mb-2">{{ vehicleDetails}}</p>
						<hr>
						<!-- Last Connection Info -->
						<div>
							<p class="mb-1"><b>{{ $t("rto.lastConnection") }}:</b> {{ formatDate(locationSelected.latest.datetime) }}
							</p>
							<p class="mb-1"><b>Latitude:</b> {{ locationSelected.latest.latitude }}</p>
							<p class="mb-1"><b>Longitude:</b> {{ locationSelected.latest.longitude }}</p>
						</div>
					</div>
				</div>
			</b-card>
			<b-card no-body  class="card-custom">
				<ridesResume :driverId="driverIdSelected"></ridesResume>
			</b-card>


		</b-modal>
	</div>
</template>

<script>
//import Multiselect from 'vue-multiselect'
import moment from "moment";
import logo from '../../../../assets/car-location.png'
import ridesResume from './DriverResumeOperation.vue'

export default {
	components: {ridesResume},
	data() {
		return {
			modalShow:false,
			logo:logo,
			map: null,
			loading:false,
			driversData:[],
			locationSelected:null,
			markers:[],
			cluster:null,
			driverIdSelected:null,
			interval:null
		};
	},
	computed: {
		vehicleDetails() {
			const { transportUnit } = this.locationSelected;
			if(this.$root.isEmpty(transportUnit)) return "--";
			return `${transportUnit.name} - Max Passengers: ${transportUnit.maxPassengers} - ID: ${transportUnit.id}`;
		},
		driverName() {
			const { driver } = this.locationSelected;
			return `${driver.firstName} ${driver.lastName}`;
		},
		salesChannelsOpts(){
			return [{group:'SELECT ALL',options: this.$root.auxVars.salesChannelsOpts}]
		}
	},
	methods: {
		addMarkersToCluster(){
			let vars ={
				map:this.map,
				markers:this.markers
			}
			this.cluster = new window.markerClusterer.MarkerClusterer(vars);
		},
		formatDate(datetime) {
			const date = new Date(datetime);
			return date.toLocaleString();
		},
		initMap() {
			if(!this.$root.isEmpty(this.map)){
				console.log("cached");
				return;
			}
			console.info("map loaded")
			this.map = new window.google.maps.Map(this.$refs["drivers-map"], {
				center: { lat: 22.268764039073968, lng:  -338.90625000000006 },
				zoom: 2,
				minZoom: 2, // Zoom mínimo permitido
				streetViewControl: false,
				styles: [ // Apply custom map styles to create a cleaner look
					{
						featureType: 'poi',
						stylers: [{ visibility: 'off' }] // Hide points of interest
					},
					{
						featureType: 'administrative',
						elementType: 'labels',
						stylers: [{ visibility: 'off' }] // Hide administrative labels
					}
            // Add more custom styles as needed to remove unwanted elements
        ]
			});
		},
		createMarkers(){
			this.driversData.forEach(element => {
				const customIcon = {
					url:this.logo, // URL of the custom icon image
					scaledSize: new window.google.maps.Size(50, 50), // Size of the icon
					origin: new window.google.maps.Point(0, 0), // Position of the icon's origin (top left corner)
					anchor: new window.google.maps.Point(16, 32) // Position of the icon's anchor (center bottom)
				};
				var myLatlng = new window.google.maps.LatLng(parseFloat(element.latest.latitude), parseFloat(element.latest.longitude));
				let txtLabel = '';
				try{
					txtLabel+= `${element.driver.firstName||''}`
					let timeAgo = moment(element.latest.datetime).fromNow();
					txtLabel += ', '+ timeAgo;
				}catch(err){
					console.log(err)
				}
				const marker = new window.google.maps.Marker({
					position: myLatlng,
					icon:customIcon,
					animation: window.google.maps.Animation.DROP,
					label: {
						text: `${txtLabel}`,
						className:'marker-label',
						// Adjust label positioning here
						// The anchor and labelOrigin parameters control the label's position relative to the marker
					},
				});
				marker.addListener("click", () => {
					this.modalShow= true;
					this.driverIdSelected   = element.driverId
					this.locationSelected = element;
					// Open the info window when marker is clicked
					//infoWindow.open(map, marker);
				});
				this.markers.push(marker);
				
			});

			this.addMarkersToCluster();
			/*var _point = new window.google.maps.LatLng(parseFloat(place.latitude), parseFloat(place.longitude))
			bounds.extend(_point);*/
		},
		clearMarkers(){
			this.markers.forEach((_marker)=>{
				_marker.setMap(null);
			})
			this.markers = [];
			if(this.cluster)this.cluster.clearMarkers();
		},
		fetchDrivers(){
			this.clearMarkers();
			this.loading = true;
			this.$root.api
			.get(`/drivers/realtime`)
			.then(res => {
				this.driversData = res.data;
				this.createMarkers();
			})
			.catch(this.$root.handleRequestError)
			.finally(()=>{
				this.loading = false;
			})
		},
		cleanInterval(){
			clearInterval(this.interval);
			this.interval=null;
		},
		listenerFn(){
			if (document.visibilityState === 'visible') {
				this.fetchDrivers();
				this.interval = setInterval(this.fetchDrivers, 10000);
			} else {
				// Tab has become hidden, pause or adjust setInterval
				this.cleanInterval();

			}
		}
	},
	mounted() {
		this.initMap();
		this.fetchDrivers();
		document.removeEventListener("visibilitychange", this.listenerFn);
		document.addEventListener("visibilitychange", this.listenerFn);
		this.interval = setInterval(this.fetchDrivers, 30000);

	},
	destroyed() {
		this.cleanInterval();
		document.removeEventListener("visibilitychange", this.listenerFn);
	},
	watch: {}
};
</script>
<style>
.card-custom{
	border-radius: 1rem !important;
}
/* Example CSS for marker tooltip styling */
.marker-label {
	color: rgb(220, 88, 88) !important;
    position: absolute;
    background-color: white;
    border: 1px solid black;
    border-radius: 3px;
    padding: 2px 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.5);
    white-space: nowrap; /* Ensure the text does not wrap */
    font-size: 11px !important; /* Adjust the font size */
    z-index: 1000; /* Ensure it appears above other elements */
}
</style>
<style scoped>

#drivers-map {
	width: 100%;
	height: 800px;
}
#zoned-rate-editor .card-body{
    color:black !important
}


</style>


